/**
 * Active right-panel registry.
 *
 * RightPanelShell is the shared chrome for every right panel, but each panel keeps its
 * open state somewhere different — ui$ for the reader and library panels, component state
 * for the deck panel. The shell registers itself here while it is on screen so the shared
 * content-width guard can close whichever panel is open without owning any of that state.
 */

let activePanel = null;

/**
 * @param {{ close: () => void }} panel
 * @returns {() => void} unregister
 */
export const registerRightPanel = (panel) => {
  activePanel = panel;
  return () => {
    if (activePanel === panel) activePanel = null;
  };
};

export const getActiveRightPanel = () => activePanel;
